/**
 * Ajido Warranty — hệ quét mã (tách khỏi warranty-v5.js)
 *
 * Phơi ra window.AjidoScan. Nạp TRƯỚC warranty-v5.js trong page.warranty.liquid.
 *
 * Vì sao có file này: BarcodeDetector chỉ có trên Chrome Android, mà khách Ajido
 * chủ yếu vào từ webview Zalo và Safari iOS.
 */
(function (window) {
  'use strict';

  var AjidoScan = {};

  /**
   * Chuẩn hoá giá trị vừa quét được.
   *
   * Phiếu TikTok có một QR quảng cáo ở góc dưới trái trỏ về trang đăng ký bán
   * hàng. Quét trúng nó mà đổ thẳng vào ô nhập thì khách nhận "không tìm thấy
   * đơn" và không hiểu vì sao — nên chặn ở đây.
   */
  AjidoScan.normalizeScanned = function (raw) {
    if (typeof raw !== 'string') { return { ok: false, reason: 'empty' }; }
    var v = raw.trim().toUpperCase();
    if (v === '') { return { ok: false, reason: 'empty' }; }
    if (v.indexOf('HTTP://') === 0 || v.indexOf('HTTPS://') === 0) {
      return { ok: false, reason: 'promo_url' };
    }
    return { ok: true, value: v };
  };

  /** Máy này quét được tới đâu. */
  AjidoScan.scanSupport = function (nav, win) {
    var w = win || window;
    var camera = !!(nav && nav.mediaDevices && typeof nav.mediaDevices.getUserMedia === 'function');
    return { camera: camera, native: camera && 'BarcodeDetector' in w };
  };

  /** Đường nhanh native nếu có, không thì ZXing. */
  AjidoScan.pickDecoder = function (win) {
    return ('BarcodeDetector' in (win || window)) ? 'native' : 'zxing';
  };

  var zxingPromise = null;

  /**
   * Nạp ZXing bằng thẻ <script>, chỉ đúng lúc khách bấm nút quét.
   * Nạp một lần rồi dùng lại cho các lần quét sau.
   */
  AjidoScan.loadZxing = function (doc, url, win) {
    var w = win || window;
    if (w.ZXing) { return Promise.resolve(w.ZXing); }
    if (zxingPromise) { return zxingPromise; }

    zxingPromise = new Promise(function (resolve, reject) {
      var el = doc.createElement('script');
      el.src = url;
      el.async = true;
      el.onload = function () {
        if (w.ZXing) { resolve(w.ZXing); }
        else { zxingPromise = null; reject(new Error('decoder_failed')); }
      };
      el.onerror = function () {
        zxingPromise = null;
        reject(new Error('decoder_failed'));
      };
      doc.head.appendChild(el);
    });
    return zxingPromise;
  };

  var DEFAULT_FORMATS = ['code_128', 'ean_13', 'qr_code'];
  var SLOW_MS = 15000;   // sau ngần này chưa ra mã thì hiện gợi ý

  /**
   * Mở camera kèm khung ngắm 16:6.
   * Hai lối thoát bắt buộc: nút Đóng và nút Nhập tay — không được để khách kẹt.
   */
  AjidoScan.openScanner = function (opts) {
    opts = opts || {};
    var nav = opts.navigator || navigator;
    var win = opts.window || window;
    var doc = opts.document || document;
    var formats = opts.formats || DEFAULT_FORMATS;

    var sup = AjidoScan.scanSupport(nav, win);
    if (!sup.camera) {
      return Promise.resolve({ status: 'unsupported', reason: 'no_camera' });
    }

    return nav.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } }).then(
      function (stream) {
        // Từ đây stream đã sống — lỗi nào rơi ra từ runOverlay (build DOM, gắn
        // decoder...) cũng phải tắt track trước khi trả kết quả, không thì
        // camera cứ sáng đèn dù overlay đã biến mất khỏi màn hình.
        return runOverlay(stream, opts, doc, win, formats).catch(function () {
          stopStream(stream);
          return { status: 'unsupported', reason: 'overlay_error' };
        });
      },
      function (err) {
        return { status: 'unsupported', reason: mapGetUserMediaError(err) };
      }
    );
  };

  function stopStream(stream) {
    if (stream && typeof stream.getTracks === 'function') {
      stream.getTracks().forEach(function (t) { t.stop(); });
    }
  }

  /**
   * getUserMedia() ném nhiều loại lỗi khác nhau, khách cần biết đường xử lý
   * khác nhau: không có camera (NotFoundError) khác hẳn máy khác đang chiếm
   * camera (NotReadableError, hay gặp trong webview) khác hẳn từ chối quyền.
   * Không nhận ra tên lỗi thì coi như từ chối quyền — trường hợp phổ biến nhất.
   */
  function mapGetUserMediaError(err) {
    var name = err && err.name;
    if (name === 'NotFoundError') { return 'not_found'; }
    if (name === 'NotReadableError') { return 'not_readable'; }
    return 'denied';
  }

  var svgCloneSeq = 0;

  function walkEls(el, fn) {
    fn(el);
    var kids = el.children;
    if (!kids) { return; }
    for (var i = 0; i < kids.length; i++) { walkEls(kids[i], fn); }
  }

  /**
   * Chép <svg> bóng phiếu cho overlay camera, đổi mới toàn bộ id bên trong
   * (pattern/mask...) và các tham chiếu url(#id) đi kèm.
   *
   * Vì sao cần: #w5-guide-slip svg (bản gốc trong khối "Mã đơn nằm ở đâu?")
   * vẫn còn trong DOM khi overlay mở — chỉ đang `hidden`. Nếu clone giữ
   * nguyên id, tài liệu có 2 phần tử cùng id #w5SlipBars/#w5SlipMask, và
   * url(#...) luôn giải về phần tử ĐẦU TIÊN theo thứ tự DOM — tức bản gốc
   * đang hidden — chứ không phải bản vừa clone vào overlay đang hiển thị.
   */
  function cloneSvgWithFreshIds(svg) {
    var clone = svg.cloneNode(true);
    var suffix = 'gscan' + (++svgCloneSeq);
    var idMap = {};

    walkEls(clone, function (el) {
      var id = el.getAttribute && el.getAttribute('id');
      if (id) {
        var fresh = id + '-' + suffix;
        idMap[id] = fresh;
        el.setAttribute('id', fresh);
      }
    });

    walkEls(clone, function (el) {
      if (!el.attributes) { return; }
      for (var i = 0; i < el.attributes.length; i++) {
        var attr = el.attributes[i];
        if (!attr.value || attr.value.indexOf('url(#') === -1) { continue; }
        var next = attr.value.replace(/url\(#([^)]+)\)/g, function (m, id) {
          return idMap[id] ? 'url(#' + idMap[id] + ')' : m;
        });
        if (next !== attr.value) { el.setAttribute(attr.name, next); }
      }
    });

    return clone;
  }
  AjidoScan.cloneSvgWithFreshIds = cloneSvgWithFreshIds;

  function runOverlay(stream, opts, doc, win, formats) {
    return new Promise(function (resolve) {
      var wrap = doc.createElement('div');
      wrap.className = 'w5-scan';
      wrap.innerHTML =
          '<video class="w5-scan-feed" autoplay playsinline muted></video>'
        + '<div class="w5-scan-win">'
        +   '<i class="w5-scan-tick tl"></i><i class="w5-scan-tick tr"></i>'
        +   '<i class="w5-scan-tick bl"></i><i class="w5-scan-tick br"></i>'
        +   '<i class="w5-scan-bar"></i>'
        + '</div>'
        + '<div class="w5-scan-ghost" aria-hidden="true"></div>'
        + '<p class="w5-scan-hint"></p>'
        + '<p class="w5-scan-tips" hidden>Khó quét? Lau ống kính · đưa gần hơn khoảng một gang tay · hoặc bấm Nhập tay bên dưới.</p>'
        + '<p class="w5-scan-warn" hidden></p>'
        + '<button type="button" class="w5-scan-close" aria-label="Đóng">✕</button>'
        + '<button type="button" class="w5-scan-manual">Nhập tay</button>';

      wrap.querySelector('.w5-scan-hint').textContent = opts.hint || '';

      // bóng phiếu: chép từ snippet hướng dẫn nếu trang có sẵn (id đổi mới
      // để không đụng id bản gốc còn hidden trong #w5-guide-slip)
      var guideSvg = doc.querySelector('#w5-guide-slip svg');
      if (guideSvg) {
        wrap.querySelector('.w5-scan-ghost').appendChild(cloneSvgWithFreshIds(guideSvg));
      }

      var video = wrap.querySelector('.w5-scan-feed');
      video.srcObject = stream;
      doc.body.appendChild(wrap);
      requestAnimationFrame(function () { wrap.classList.add('is-on'); });

      var slowTimer = setTimeout(function () {
        var tips = wrap.querySelector('.w5-scan-tips');
        if (tips) { tips.hidden = false; }
      }, SLOW_MS);

      var closed = false;
      function finish(result) {
        if (closed) { return; }
        closed = true;
        clearTimeout(slowTimer);
        win.removeEventListener('hashchange', onBack);
        win.removeEventListener('popstate', onBack);
        doc.removeEventListener('keydown', onKeydown);
        stream.getTracks().forEach(function (t) { t.stop(); });
        wrap.remove();
        resolve(result);
      }

      // Nút Back Android điều hướng trang PHÍA DƯỚI qua hashchange (warranty-v5.js
      // đổi route khi hash đổi) trong khi overlay — và camera đang bật — vẫn
      // đứng nguyên phía trên nếu không tự đóng theo. Escape là lối thoát tương
      // đương cho bàn phím/desktop.
      function onBack() { finish({ status: 'cancelled' }); }
      function onKeydown(e) {
        if (e && (e.key === 'Escape' || e.keyCode === 27)) { finish({ status: 'cancelled' }); }
      }
      win.addEventListener('hashchange', onBack);
      win.addEventListener('popstate', onBack);
      doc.addEventListener('keydown', onKeydown);

      wrap.querySelector('.w5-scan-close').addEventListener('click', function () {
        finish({ status: 'cancelled' });
      });
      wrap.querySelector('.w5-scan-manual').addEventListener('click', function () {
        finish({ status: 'manual' });
      });

      function onRaw(raw) {
        var norm = AjidoScan.normalizeScanned(raw);
        if (norm.ok) {
          var winEl = wrap.querySelector('.w5-scan-win');
          winEl.classList.add('is-hit');
          if (nav_vibrate(win)) { win.navigator.vibrate(30); }
          setTimeout(function () { finish({ status: 'ok', value: norm.value }); }, 320);
          return true;
        }
        if (norm.reason === 'promo_url') { showWarn(wrap); }
        return false;   // giữ camera mở, cho quét lại
      }

      startDecoding(video, formats, win, doc, onRaw, function () {
        finish({ status: 'unsupported', reason: 'decoder_failed' });
      }, function () { return closed; });
    });
  }

  function nav_vibrate(win) {
    return !!(win.navigator && typeof win.navigator.vibrate === 'function');
  }

  var warnTimer = null;
  function showWarn(wrap) {
    var el = wrap.querySelector('.w5-scan-warn');
    var winEl = wrap.querySelector('.w5-scan-win');
    el.textContent = 'Đó là mã quảng cáo trên phiếu — hãy đưa khung vào mã vạch dài phía trên.';
    el.hidden = false;
    winEl.classList.add('is-bad');
    clearTimeout(warnTimer);
    warnTimer = setTimeout(function () {
      el.hidden = true;
      winEl.classList.remove('is-bad');
    }, 4200);
  }

  /** Vòng đọc khung hình. Chọn native hay ZXing rồi lặp cho tới khi có mã. */
  function startDecoding(video, formats, win, doc, onRaw, onFail, isClosed) {
    if (AjidoScan.pickDecoder(win) === 'native') {
      var detector = null;
      try {
        detector = new win.BarcodeDetector({ formats: formats });
      } catch (e) {
        detector = null;   // dung duoc constructor nhung khong dung len duoc: roi xuong nhanh ZXing
      }
      if (detector) {
        var tick = function () {
          if (isClosed()) { return; }
          detector.detect(video).then(function (codes) {
            if (codes && codes.length && onRaw(codes[0].rawValue)) { return; }
            requestAnimationFrame(tick);
          }).catch(function () { requestAnimationFrame(tick); });
        };
        requestAnimationFrame(tick);
        return;
      }
    }

    // URL thật của asset do Liquid sinh (asset_url), nhét sẵn vào data-src
    var srcEl = doc.querySelector('#w5-zxing-src');
    var zxingUrl = (srcEl && srcEl.dataset && srcEl.dataset.src) || 'zxing.min.js';
    AjidoScan.loadZxing(doc, zxingUrl, win).then(function (ZXing) {
      var reader = new ZXing.BrowserMultiFormatReader();
      reader.decodeFromVideoElement(video, function (result) {
        if (isClosed()) { reader.reset(); return; }
        if (result && onRaw(result.getText())) { reader.reset(); }
      });
    }).catch(function () { onFail(); });
  }

  /* ===== điều khiển hoạt ảnh "Mã đơn nằm ở đâu?" ========================= */
  var guideLoop = null;

  function guideEls(doc) {
    return {
      box: doc.getElementById('w5-guide'),
      toggle: doc.getElementById('w5-guide-toggle'),
      slip: doc.querySelector('#w5-guide-slip .w5-slip'),
    };
  }

  AjidoScan.guide = {
    open: function (doc) {
      var e = guideEls(doc || document);
      if (!e.box) { return; }
      e.box.hidden = false;
      if (e.toggle) { e.toggle.setAttribute('aria-expanded', 'true'); }
      AjidoScan.guide.play(doc);
    },

    close: function (doc) {
      var e = guideEls(doc || document);
      if (!e.box) { return; }
      e.box.hidden = true;
      if (e.toggle) { e.toggle.setAttribute('aria-expanded', 'false'); }
      clearTimeout(guideLoop);
    },

    /** Chạy 3 vòng rồi dừng — lặp mãi vừa chóng mặt vừa tốn pin. */
    play: function (doc) {
      var d = doc || document;
      var slip = guideEls(d).slip;
      if (!slip) { return; }
      clearTimeout(guideLoop);

      var reduced = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) {
        slip.classList.remove('is-playing');
        slip.classList.add('is-still');
        return;
      }

      var round = 0;
      var step = function () {
        slip.classList.remove('is-playing');
        void slip.offsetWidth;              // ép tính lại để animation chạy lại từ đầu
        slip.classList.add('is-playing');
        round += 1;
        if (round < 3) { guideLoop = setTimeout(step, 4600); }
      };
      step();
    },
  };

  /**
   * Nút bung/thu, gắn khi trang đã dựng xong.
   *
   * Nút được render `hidden` sẵn trong Liquid — nếu file này lỡ không nạp
   * được (CDN lỗi, mạng rớt...) thì khách không bao giờ thấy một nút bấm
   * vào không phản ứng gì. Chỉ bỏ hidden SAU KHI đã gắn xong listener.
   */
  AjidoScan.initGuide = function (doc) {
    var d = doc || document;
    var e = guideEls(d);
    if (!e.toggle || !e.box) { return; }
    e.toggle.addEventListener('click', function () {
      if (e.box.hidden) { AjidoScan.guide.open(d); }
      else { AjidoScan.guide.close(d); }
    });
    e.toggle.hidden = false;
  };

  if (typeof document !== 'undefined' && document.addEventListener) {
    document.addEventListener('DOMContentLoaded', function () { AjidoScan.initGuide(document); });
  }

  /**
   * Tra không ra đơn thì đi đâu tiếp.
   *
   * Lần đầu giữ khách ở màn nhập mã vì nguyên nhân phổ biến nhất là gõ nhầm —
   * đẩy thẳng sang form tự nhập là mất luôn liên kết đơn hàng. Lần thứ hai thì
   * chấp nhận là khách thật sự không có mã.
   */
  AjidoScan.notFoundNext = function (missCount) {
    return missCount >= 1 ? 'manual' : 'stay';
  };

  window.AjidoScan = AjidoScan;
})(typeof window !== 'undefined' ? window : globalThis);
